export enum UsersRouteRedirectTypeEnum {
  chw = 'chw',
  teamLeads = 'team-leads',
  admins = 'Administrator',
}

export enum UsersRolesTypeEnum {
  chw = 'Community Health Worker',
  teamLeads = 'Team Lead',
  user = 'User',
  administrator = 'Administrator',
}

export enum idTypeEnum {
  idNumber = 'idNumber',
  passport = 'Passport',
}
